import React, {Component} from 'react';
import Translator from 'bazinga-translator';
import icons from './icons';

export default class Options extends Component {
    constructor() {
        super();
    }

    handleCrop() {
        this.props.handleCrop(true);
    }

    handleDelete(e) {
        e.preventDefault();
        this.props.handleDelete(null)
    }

    handleMediaChange() {
        let files = this.refs.newUpload.files;
        if (files.length > 0) {
            let formData = new FormData();
            formData.append('image', files[0]);

            this.props.onFileChange(formData);
        }
    }

    render() {
        const titleVisibility = {display: this.props.uploaderType !== null ? 'none' : 'block'};
        return (
        <div className="upload-options">
            <span style={titleVisibility}>{Translator.trans('media_uploader.options', [], 'app')}</span>
            <ul className="upload-options__list">
                <li>
                    <label>
                        <input type="file"
                               onChange={::this.handleMediaChange}
                               ref="newUpload"
                               id="option_change"
                        />
                        <div className="option_icon">
                            {icons.changeIcon}
                            <span>{Translator.trans('media_uploader.change', [], 'app')}</span>
                        </div>
                    </label>
                </li>
                <li onClick={::this.handleCrop}>
                    <div className="option_icon">
                        {icons.cropIcon}
                        <span>{Translator.trans('media_uploader.crop', [], 'app')}</span>
                    </div>
                </li>
                <li onClick={::this.handleDelete}>
                    <div className="option_icon">
                        {icons.deleteIcon}
                        <span>{Translator.trans('media_uploader.remove', [], 'app')}</span>
                    </div>
                </li>
            </ul>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/Options.jsx